var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStorage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 21.1031L22.5 6L0 21.1031V26.1094L2.49975 24.4298V38.625H4.9995V34.4535L16.7299 14.8819L22.5 11.0062L28.2712 14.8819L40.0005 34.4535V38.625H42.5003V24.4298L45 26.1094V21.1031ZM4.5 31.875V22.875H9L4.5 31.875ZM11.0059 21.75H5.625L14.625 16.125L11.0059 21.75ZM31.5 16.125L40.5 21.75H35.1191L31.5 16.125ZM34.875 22.875H39.375V31.875L34.875 22.875Z",
    fill: "#58585A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStorage);
export default __webpack_public_path__ + "static/media/ic-storage.f8acb6b4fd8f2de8761b7af87ddc3dd7.svg";
export { ForwardRef as ReactComponent };